import { NgModule } from '@angular/core';
import { GgSimplePromoBannerComponent } from './gg-simple-promo-banner.component';
import { GgCmsLinkComponent } from '../gg-footer/gg-cms-link/gg-cms-link.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CommonModule } from '@angular/common';
import { GenericLinkModule, OutletModule, PageComponentModule } from '@spartacus/storefront';

@NgModule({
  declarations: [
    GgSimplePromoBannerComponent,
  ],
  imports: [
    CommonModule,
    PageComponentModule,
    OutletModule,
    GenericLinkModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GGCMSLinkComponent: {
          component: GgCmsLinkComponent,
        },
        GGSimplePromoBannerComponent: {
          component: GgSimplePromoBannerComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class GgSimplePromoBannerModule {}
